import { WarehouseStockItemId } from 'app/common/types/id'
import { TdProps } from 'app/common/ui-components/table'

export enum WarehouseStockTableColumn {
  Check = 'check',
  Title = 'title',
  Unit = 'unit',
  Stock = 'stock',
  Actions = 'actions',
}

export const warehouseStockTableColumnsArrange: Array<WarehouseStockTableColumn> = [
  WarehouseStockTableColumn.Check,
  WarehouseStockTableColumn.Title,
  WarehouseStockTableColumn.Unit,
  WarehouseStockTableColumn.Stock,
  WarehouseStockTableColumn.Actions,
]

export const warehouseStockTableHeaders: Array<Record<WarehouseStockTableColumn, string>> = [
  {
    [WarehouseStockTableColumn.Check]: '',
    [WarehouseStockTableColumn.Title]: 'Наименование',
    [WarehouseStockTableColumn.Unit]: 'Единица измерения,\u00A0г/шт',
    [WarehouseStockTableColumn.Stock]: 'Остаток,\u00A0г/шт',
    [WarehouseStockTableColumn.Actions]: 'Действия',
  },
]

export const warehouseStockTableCellProps: Record<WarehouseStockTableColumn, Partial<TdProps>> = {
  [WarehouseStockTableColumn.Check]: { alignLeft: true, width: 50 },
  [WarehouseStockTableColumn.Title]: { alignLeft: true, width: 450 },
  [WarehouseStockTableColumn.Unit]: { alignLeft: true },
  [WarehouseStockTableColumn.Stock]: { alignLeft: true },
  [WarehouseStockTableColumn.Actions]: { alignLeft: true },
}

export type WarehouseStockTableDataItem = {
  id: WarehouseStockItemId
  [WarehouseStockTableColumn.Check]: string
  [WarehouseStockTableColumn.Title]: string
  [WarehouseStockTableColumn.Unit]: string
  [WarehouseStockTableColumn.Stock]: { quantity: number; onSuccess?: () => void }
  [WarehouseStockTableColumn.Actions]: {
    createDishMovementLink?: (dishId: WarehouseStockItemId) => string
  }
}
